export default "__VITE_ASSET__c3729caf__"